import APICall from "../utils/APICall"

export default class AuditServices {
    static listCustomerAudit = async (page, pageLimit, search, from, to) => {
        return await APICall(`/api/Audit/admin/list-user-audit-log?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`, "GET")
    }
    static exportCustomerAudit = async (search, from, to) => {
        return await APICall(`/api/Audit/admin/export-user-audit-log?search=${search}&from=${from}&to=${to}`, "GET")
    }
    static listAdminAudit = async (page, pageLimit, search, from, to) => {
        return await APICall(`/api/Audit/admin/list-admin-audit-log?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`, "GET")
    }
    static exportAdminAudit = async (search, from, to) => {
        return await APICall(`/api/Audit/admin/export-admin-audit-log?search=${search}&from=${from}&to=${to}`, "GET")
    }
}